import ContentHandler from '../schema/ContentHandler';
import { lazyMountBohemiaComponent, lazyTryGetBohemiaDriverForUrl } from 'owa-prague-integrations';

export const PRAGUE_HANDLER_NAME = 'pragueHandler';
const PRAGUE_SELECTOR = 'a';
const ORIGINALSRC_ATTTIBUTE_NAME = 'originalsrc';

export class PragueHandler implements ContentHandler {
    public readonly cssSelector = PRAGUE_SELECTOR;
    public readonly keywords = null;
    private storeElements: {
        originalAnchor: HTMLElement;
        pragueContentHost: HTMLElement;
    }[];
    private linksHydrated: string[] = [];

    constructor() {
        this.storeElements = [];
    }

    public readonly handler = (element: HTMLElement) => {
        const href = element.hasAttribute(ORIGINALSRC_ATTTIBUTE_NAME)
            ? element.getAttribute(ORIGINALSRC_ATTTIBUTE_NAME)
            : (element as HTMLAnchorElement).href;
        //Links without text in them (i.e. image links) should not be hydrated
        //If we've already hydrated a specific link before, don't hydrate it again.
        const trimmedContent = element.textContent.trim();
        if (trimmedContent && this.linksHydrated.indexOf(href) == -1) {
            // add it here, if it fails remove it.
            this.linksHydrated.push(href);
            lazyTryGetBohemiaDriverForUrl.import().then(tryGetBohemiaDriverForUrl => {
                const driverInfo = tryGetBohemiaDriverForUrl(href);
                if (driverInfo) {
                    lazyMountBohemiaComponent.import().then(mountBohemiaComponent => {
                        if (mountBohemiaComponent && element && document.body.contains(element)) {
                            const placeholderDiv = element.ownerDocument.createElement('div');
                            const oldElement = element.parentElement.replaceChild(
                                placeholderDiv,
                                element
                            );
                            mountBohemiaComponent(placeholderDiv, driverInfo)
                                .then(() => {
                                    this.storeElements.push({
                                        originalAnchor: oldElement,
                                        pragueContentHost: placeholderDiv,
                                    });
                                })
                                .catch(() => {
                                    placeholderDiv.parentNode.replaceChild(
                                        oldElement,
                                        placeholderDiv
                                    );
                                    this.linksHydrated.splice(this.linksHydrated.indexOf(href), 1);
                                });
                        }
                    });
                }
            });
        }
    };

    public readonly undoHandler = (elements: HTMLElement[]) => {
        this.storeElements.forEach(storeElement => {
            const { originalAnchor, pragueContentHost } = storeElement;
            pragueContentHost.parentNode.replaceChild(originalAnchor, pragueContentHost);
        });
        this.storeElements = [];
        this.linksHydrated = [];
    };
}

export default function createPragueHandler(): PragueHandler {
    return new PragueHandler();
}
